import { render, staticRenderFns } from "./InfoShowDialog.vue?vue&type=template&id=fbb1fd3a&"
import script from "./InfoShowDialog.vue?vue&type=script&lang=js&"
export * from "./InfoShowDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports